import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RolesAPI } from '../../../api/roleApi';
import { Can } from '../../../casl/Can';
import ConfirmationModal from '../../../modal/ConfirmationModal';
import { deleteFamilyUserRole } from '../../../store/family-user-role/actions';
import { familyUserRolesSelector } from '../../../store/family-user-role/selectors';
import { DeleteFamilyUserRole } from '../../../store/family-user-role/types';

type FamilyUserRoleTableProps = {
  editBtnClick?: (roleId: string) => any;
  addRoleBtnClick?: () => void;
};

const FamilyUserRoleTable: React.FC<FamilyUserRoleTableProps> = ({
  editBtnClick = () => {},
  addRoleBtnClick = () => {},
}) => {
  const familyUserRoles = useSelector(familyUserRolesSelector);
  const [roleToDelete, setRoleToDelete] = React.useState('');
  const dispatch = useDispatch();

  const deleteRoleLocal = (e, roleId: string) => {
    RolesAPI.deleteFamilyUserRole(roleId)
      .then(() => {
        dispatch<DeleteFamilyUserRole>(deleteFamilyUserRole(roleId));
      })
      .catch((e) => {
        alert(e.message);
      });
  };

  return (
    <>
      <div className='card'>
        <div className='table-responsive'>
          <table className='table table-sm table-nowrap card-table table-bordered'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {familyUserRoles.length > 0
                ? familyUserRoles.map((role) => {
                    return (
                      <tr key={role._id}>
                        <td>
                          <h4 className='font-weight-bold'>{role.name}</h4>
                          {role.selfSelectable === false && (
                            <span className='badge badge-soft-warning p-2 mr-2'>Admin only</span>
                          )}
                          {(role.allowedEmailDomains ?? []).map((domain) => (
                            <span key={domain} className='badge badge-soft-primary p-2 mr-2'>
                              @{domain}
                            </span>
                          ))}
                        </td>
                        <td className='text-center w-25'>
                          <div className='btn-group'>
                            <Can I='update' a='role'>
                              <button
                                className='btn btn-light btn-sm'
                                onClick={() => {
                                  editBtnClick(role._id || '');
                                }}
                              >
                                Edit
                              </button>
                            </Can>
                            <Can I='delete' a='role'>
                              <button
                                className='btn btn-danger btn-sm'
                                data-toggle='modal'
                                onClick={() => setRoleToDelete(role._id || '')}
                                data-target='#delete-family-user-role'
                              >
                                Delete
                              </button>
                            </Can>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>
      </div>
      <Can I='delete' a='role'>
        <ConfirmationModal
          id='delete-family-user-role'
          label='You want to delete this user role?'
          message='Are you sure?'
          danger={true}
          handleYes={deleteRoleLocal}
          idToDelete={roleToDelete}
        />
      </Can>
      <Can I='create' a='role'>
        <button className='btn btn-rounded-circle btn-success btn-bottom-right-fixed m-3' onClick={addRoleBtnClick}>
          <span className='fe fe-plus'></span>
        </button>
      </Can>
    </>
  );
};

export default FamilyUserRoleTable;
